import type { FC } from 'react';

import CriticalPriorityIcon from 'icons/CriticalPriorityIcon';
import HighPriorityIcon from 'icons/HighPriorityIcon';
import LowPriorityIcon from 'icons/LowPriorityIcon';
import MediumPriorityIcon from 'icons/MediumPriorityIcon';

import { PriorityIconButtonStyled, PriorityIconButtonWrapStyled } from './PriorityIcon.styled';

export type PriorityIconPropsT = {
  priority: string;
};

const PriorityIcon: FC<PriorityIconPropsT> = ({ priority }) => (
  <PriorityIconButtonWrapStyled title={priority}>
    {priority === 'Low' && (
      <PriorityIconButtonStyled variant="contained" icon={<LowPriorityIcon size="sm" />} />
    )}
    {priority === 'Medium' && (
      <PriorityIconButtonStyled variant="contained" icon={<MediumPriorityIcon size="sm" />} />
    )}
    {priority === 'High' && (
      <PriorityIconButtonStyled variant="contained" icon={<HighPriorityIcon size="sm" />} />
    )}
    {priority === 'Critical' && (
      <PriorityIconButtonStyled variant="contained" icon={<CriticalPriorityIcon size="sm" />} />
    )}
  </PriorityIconButtonWrapStyled>
);

export default PriorityIcon;
